// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CertificateDetails_root__FmoEb {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 32px;
}
.CertificateDetails_root__FmoEb section {
  color: #111111;
  overflow: hidden;
}
.CertificateDetails_root__FmoEb section .CertificateDetails_alert__v9RV- {
  justify-content: center;
}
.CertificateDetails_root__FmoEb section header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
  align-items: center;
}
.CertificateDetails_root__FmoEb section header .CertificateDetails_title__0VfkI {
  font-size: 16px;
}
.CertificateDetails_root__FmoEb section .CertificateDetails_field__60MrU {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  line-height: 34px;
}
.CertificateDetails_root__FmoEb section .CertificateDetails_field__60MrU .CertificateDetails_label__Hatuv {
  color: rgba(17, 17, 17, 0.568627451);
}
.CertificateDetails_root__FmoEb section .CertificateDetails_field__60MrU .CertificateDetails_value__E2xzN {
  display: flex;
  gap: 2px;
  align-items: center;
}
.CertificateDetails_root__FmoEb section .CertificateDetails_field__60MrU .CertificateDetails_value__E2xzN .CertificateDetails_view3d__VLhVL {
  display: flex;
  align-items: center;
  opacity: 0.54;
  font-size: 12px;
  color: rgba(17, 17, 17, 0.84);
}
.CertificateDetails_root__FmoEb .CertificateDetails_aspects__QM1WQ {
  padding-bottom: 32px;
}
.CertificateDetails_root__FmoEb .CertificateDetails_aspects__QM1WQ .nav-tabs {
  padding: 10px 16px 0;
}
.CertificateDetails_root__FmoEb .CertificateDetails_aspects__QM1WQ .CertificateDetails_goc__20ZhO .CertificateDetails_gocFields__f1u9m {
  display: flex;
  gap: 32px;
  padding: 28px;
}
.CertificateDetails_root__FmoEb .CertificateDetails_title__0VfkI {
  padding: 16px 24px;
  font-size: 20px;
  font-weight: 300;
  color: #111111;
  white-space: nowrap;
  max-width: 500px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.CertificateDetails_root__FmoEb .nav-link {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/CertificateDetails/CertificateDetails.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACF;AAAE;EACE,cAAA;EACA,gBAAA;AAEJ;AADI;EACE,uBAAA;AAGN;AADI;EACE,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,mBAAA;AAGN;AAFM;EACE,eAAA;AAIR;AADI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AAGN;AAFM;EACE,oCAAA;AAIR;AAFM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAIR;AAHQ;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;AAKV;AACE;EACE,oBAAA;AACJ;AAAI;EACE,oBAAA;AAEN;AACM;EACE,aAAA;EACA,SAAA;EACA,aAAA;AACR;AAIE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;AAHJ","sourcesContent":[".root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  margin-top: 16px;\r\n  margin-bottom: 32px;\r\n  section {\r\n    color: #111111;\r\n    overflow: hidden;\r\n    .alert {\r\n      justify-content: center;\r\n    }\r\n    header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      border-bottom: 1px solid #dedede;\r\n      align-items: center;\r\n      .title {\r\n        font-size: 16px;\r\n      }\r\n    }\r\n    .field {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      font-size: 15px;\r\n      line-height: 34px;\r\n      .label {\r\n        color: #11111191;\r\n      }\r\n      .value {\r\n        display: flex;\r\n        gap: 2px;\r\n        align-items: center;\r\n        .view3d {\r\n          display: flex;\r\n          align-items: center;\r\n          opacity: 0.54;\r\n          font-size: 12px;\r\n          color: rgba(17, 17, 17, 0.84);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .aspects {\r\n    padding-bottom: 32px;\r\n    :global(.nav-tabs) {\r\n      padding: 10px 16px 0;\r\n    }\r\n    .goc {\r\n      .gocFields {\r\n        display: flex;\r\n        gap: 32px;\r\n        padding: 28px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .title {\r\n    padding: 16px 24px;\r\n    font-size: 20px;\r\n    font-weight: 300;\r\n    color: #111111;\r\n    white-space: nowrap;\r\n    max-width: 500px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n  }\r\n\r\n  :global(.nav-link) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CertificateDetails_root__FmoEb`,
	"alert": `CertificateDetails_alert__v9RV-`,
	"title": `CertificateDetails_title__0VfkI`,
	"field": `CertificateDetails_field__60MrU`,
	"label": `CertificateDetails_label__Hatuv`,
	"value": `CertificateDetails_value__E2xzN`,
	"view3d": `CertificateDetails_view3d__VLhVL`,
	"aspects": `CertificateDetails_aspects__QM1WQ`,
	"goc": `CertificateDetails_goc__20ZhO`,
	"gocFields": `CertificateDetails_gocFields__f1u9m`
};
export default ___CSS_LOADER_EXPORT___;
